/**
 * Relative wording near today, absolute further out.
 *
 * Shared so every surface says the same thing about the same date. The review
 * screens previously rendered a raw `2026-07-28` beside a Today screen calling
 * it "Today", which reads as two different dates at a glance.
 */
export function formatDateChip(date: string, today: string): string {
  if (date === today) return 'Today'

  const diff = Math.round(
    (Date.parse(`${date}T12:00:00Z`) - Date.parse(`${today}T12:00:00Z`)) /
      86_400_000,
  )

  if (diff === 1) return 'Tomorrow'
  if (diff === -1) return 'Yesterday'

  const parsed = new Date(`${date}T12:00:00Z`)
  if (diff > 1 && diff <= 6) {
    return parsed.toLocaleDateString(undefined, {
      weekday: 'short',
      timeZone: 'UTC',
    })
  }
  return parsed.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  })
}
